"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.filterItinerariesWithFareFamilies = filterItinerariesWithFareFamilies;
exports.formatFareFamilyResults = formatFareFamilyResults;
exports.getBrandedFares = getBrandedFares;
exports.getCombinedId = getCombinedId;
exports.getFareFamiliesFromItineraries = getFareFamiliesFromItineraries;
exports.getFareFamiliesFromItineraryHashMap = getFareFamiliesFromItineraryHashMap;
exports.getFetchFareFamiliesConfig = getFetchFareFamiliesConfig;
var _map2 = _interopRequireDefault(require("lodash/map"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));
var _findKey2 = _interopRequireDefault(require("lodash/findKey"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _join2 = _interopRequireDefault(require("lodash/join"));
var _searchResults = require("./search-results.utils");
var _brandedFares = require("../factories/branded-fares.factory");
var _fareFamilyItinerary = require("../factories/fare-family-itinerary.factory");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _constants = require("../constants");
function filterItinerariesWithFareFamilies(itineraryHashMap) {
  return (0, _filter2.default)(itineraryHashMap, function (itinerary) {
    return Boolean(itinerary === null || itinerary === void 0 ? void 0 : itinerary.fareFamilies);
  });
}
function getBrandedFares(response, $env) {
  var _response$data;
  return (0, _keyBy2.default)((0, _map2.default)(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.brandedFares, function (fares, code) {
    var _response$data2, _response$data2$airli;
    return (0, _brandedFares.brandedFaresFactory)({
      fares: fares,
      code: (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$airli = _response$data2.airline) === null || _response$data2$airli === void 0 ? void 0 : _response$data2$airli[0]) + "_" + code,
      $currency: $env.currency
    });
  }), "code");
}
function getFareFamiliesFromItineraryHashMap(itineraryHashMap) {
  var itineraryKey = (0, _findKey2.default)(itineraryHashMap, function (i) {
    return !(0, _isEmpty2.default)(i.fareFamilies) && !i.isExcluded;
  });
  var itinerary = itineraryHashMap[itineraryKey];
  var itinerariesLength = (0, _size2.default)(itineraryHashMap);
  var fareFamilies = (0, _get2.default)(itinerary, "fareFamilies", []);
  if (itinerariesLength === 1) {
    var firstItinerary = (0, _first2.default)(Object.values(itineraryHashMap));
    fareFamilies = [(0, _fareFamilyItinerary.fareFamilyItineraryFactory)(firstItinerary)];
  }
  return fareFamilies;
}
function formatFareFamilyResults(_ref) {
  var searchResults = _ref.searchResults,
    searchRequest = _ref.searchRequest,
    $currency = _ref.$currency;
  var _formatSearchResults = (0, _searchResults.formatSearchResults)({
      searchResults: searchResults,
      searchRequest: searchRequest,
      $currency: $currency,
      config: {
        showAgentResults: false
      }
    }),
    itineraryHashMap = _formatSearchResults.itineraryHashMap;
  var fareFamilies = getFareFamiliesFromItineraryHashMap(itineraryHashMap);
  return {
    itineraryHashMap: itineraryHashMap,
    fareFamilies: fareFamilies
  };
}
function getFareFamiliesFromItineraries(itineraries) {
  var itinerariesFareFamilies = (0, _map2.default)(itineraries, function (itinerary) {
    return {
      id: itinerary.id,
      fareFamilies: itinerary.fareFamilies
    };
  });
  return (0, _keyBy2.default)(itinerariesFareFamilies, "id");
}
function getFetchFareFamiliesConfig(_ref2) {
  var outboundItinerary = _ref2.outboundItinerary,
    inboundItinerary = _ref2.inboundItinerary,
    direction = _ref2.direction;
  var payload = {
    outboundItineraryId: outboundItinerary === null || outboundItinerary === void 0 ? void 0 : outboundItinerary.id,
    inboundItineraryId: inboundItinerary === null || inboundItinerary === void 0 ? void 0 : inboundItinerary.id,
    direction: direction
  };
  return {
    payload: payload
  };
}
function getCombinedId(_ref3) {
  var outboundId = _ref3.outboundId,
    inboundId = _ref3.inboundId,
    direction = _ref3.direction;
  return (0, _join2.default)([outboundId, inboundId, direction], _constants.DOMESTIC_ID_SEPARATOR);
}